// TODO: resolve CHCP disables by bot
// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';
import {
  User,
  TinAccess,
  EditedUser,
  EntitlementRole,
  EligibleJobRoles,
  UserTinLob,
} from '../manage-access.model';
import { FILTER_GROUP } from '../manage-access.constant';
import { ServiceError, TinLob } from '@cigna/chcp/shared/util';

export const RESET = '[Manage User Access] Reset';

export const GET_ALL_USERS = '[Manage User Access] Get All Users';
export const GET_ALL_USERS_ERROR = '[Manage User Access] Get All Users Error';
export const GET_ALL_USERS_SUCCESS =
  '[Manage User Access] Get All Users Loaded';

export const GET_PENDING_USERS = '[Manage User Access] Get Pending Users';
export const GET_PENDING_USERS_ERROR =
  '[Manage User Access] Get Pending Users Error';
export const GET_PENDING_USERS_SUCCESS =
  '[Manage User Access] Get Pending Users Loaded';

export const GET_APPROVED_USERS = '[Manage User Access] Get Approved Users';
export const GET_APPROVED_USERS_ERROR =
  '[Manage User Access] Get Approved Users Error';
export const GET_APPROVED_USERS_SUCCESS =
  '[Manage User Access] Get Approved Users Loaded';

export const GET_USERS_CACHED = '[Manage User Access] Get Users Cached';

export const GET_USER_TIN_ENTITLEMENTS =
  '[Manage User Access] Get User Tin Entitlements';
export const GET_USER_TIN_ENTITLEMENTS_SUCCESS =
  '[Manage User Access] Get User Tin Entitlements Success';

export const GET_JOB_ROLES = '[Manage User Access] Get job roles';
export const GET_JOB_ROLES_SUCCESS =
  '[Manage User Access] Get job roles success';

export const GET_ENTITLEMENTS = '[Manage User Access] Get entitlements';
export const GET_ENTITLEMENTS_SUCCESS =
  '[Manage User Access] Get entitlements success';

export const GET_ELIGIBLE_JOB_ROLES =
  '[Manage User Access] Get eligible job roles';
export const GET_ELIGIBLE_JOB_ROLES_SUCCESS =
  '[Manage User Access] Get eligible job roles success';

export const GET_ALL_TINS = '[Manage User Access] Get all tins';
export const GET_ALL_TINS_SUCCESS = '[Manage User Access] Get all tins success';

export const PAGE_OVERVIEW_FILTER_GROUP_CHANGE =
  '[Manage User Access] Overview Change Filter State';
export const PAGE_OVERVIEW_FILTER_TEXT_CHANGE =
  '[Manage User Access] Overview Change Filter Text';

export const PAGE_CHANGE_SCREEN = '[Manage User Access] Change Screen';

export const CANCEL_EDIT_USER_FLOW =
  '[Manage User Access] Cancel edit user flow';
export const ADD_USERS_AND_START_ASSIGNMENT =
  '[Manage User Access] Add new users and start assignment';
export const SELECT_AND_EDIT_USER = '[Manage User Access] Select and edit user';
export const VIEW_AND_EDIT_USERS = '[Manage User Access] View and edit users';
export const SET_ASSIGNMENT_METHOD_AND_ASSIGN =
  '[Manage User Access] Set Assignment method and assign';

export const VIEW_ACCESS_FOR_USER = '[Manage User Access] View Access for User';
export const VIEW_ACCESS_FOR_USER_SUCCESS =
  '[Manage User Access] View Access for User Success';
export const VIEW_ACCESS_FOR_USER_ERROR =
  '[Manage User Access] View Access for User Error';
export const VIEW_ACCESS_FOR_USER_RESET =
  '[Manage User Access] View Access for User Reset';

export const ADD_NEW_USERS = '[Manage User Access] Add New Users';

export const SELECT_USER_TO_EDIT = '[Manage User Access] Select user to edit';
export const UNSELECT_USER_TO_EDIT =
  '[Manage User Access] UnSelect user to edit';
export const SELECT_ALL_USERS_TO_EDIT = '[Manage User Access] Select all users';
export const UNSELECT_ALL_USERS_TO_EDIT =
  '[Manage User Access] UnSelect all users';

export const SET_SELECTED_USERS = '[Manage User Access] Set Selected Users';
export const SCAFFOLD_SELECTED_USERS =
  '[Manage User Access] Scaffold Selected Users';

export const TRIGGER_USER_SCAFFOLDING =
  '[Manage User Access] Trigger Users Scaffolding';

export const APPLY_ENTITLEMENTS_BY_JOB_ROLE =
  '[Manage User Access] Apply Entitlements By Job Role';
export const REVERT_ENTITLEMENTS_TO_EXISTING =
  '[Manage User Access] Revert Entitlements to Existing';
export const UPDATE_EDITED_USER_INDIVIDUAL =
  '[Manage User Access] Update Edited User Individual';

export const UPDATE_EDITED_USERS_BULK_ENTITLEMENTS =
  '[Manage User Access] Update Edited User Bulk Entitlments';
export const UPDATE_EDITED_USERS_BULK_TINS =
  '[Manage User Access] Update Edited Bulk Tins';

export const BULK_EDIT_APPLY_CHANGES =
  '[Manage User Access] Bulk Edit Apply Changes';
export const UPDATE_EDITED_USERS_BULK_AND_CONTINUE =
  '[Manage User Access] Update Edited Users Bulk and Continue';

export const SHOW_EDIT_ERRORS = '[Manage User Access] Show Edit Errors';
export const PROCEED_WITH_EDIT_ERRORS =
  '[Manage User Access] Proceed with Edit Errors';

export const SELECT_USER_TO_PRINT_EMAIL =
  '[Manage User Access] Select User to Print or Email';
export const UNSELECT_USER_TO_PRINT_EMAIL =
  '[Manage User Access] UnSelect User to Print or Email';
export const SELECT_ALL_USERS_TO_PRINT_EMAIL =
  '[Manage User Access] Select All Users to Print or Email';

export const BACK_TO_ASSIGN_ACCESS =
  '[Manage User Access] Back to Assign Access';

export const USERS_SUBMIT = '[Manage User Access] Users Submit';

export const ASSIGN_USERS_SUBMIT = '[Manage User Access] Assign Users Submit';
export const ASSIGN_USERS_SUCCESS = '[Manage User Access] Assign Users Success';
export const ASSIGN_USERS_ERROR = '[Manage User Access] Assign Users Error';
export const ADD_USERS_NO_LOB_ERROR =
  '[Manage User Access] Assign Users No Lob Error';

export const ADD_USERS_SUBMIT = '[Manage User Access] Add Users Submit';
export const ADD_USERS_SUCCESS = '[Manage User Access] Add Users Success';
export const ADD_USERS_SUCCESS_MERGE =
  '[Manage User Access] Add Users Success Merge Data';
export const ADD_USERS_ERROR = '[Manage User Access] Add Users Error';

export const USER_REMOVE_ACCESS = '[Manage User Access] Remove Access for User';
export const USER_REMOVE_ACCESS_SUCCESS =
  '[Manage User Access] Remove Access Success';
export const USER_REMOVE_ACCESS_ERROR =
  '[Manage User Access] Remove Access Error';
export const USER_REMOVE_ACCESS_RESET =
  '[Manage User Access] Remove Access Reset';

export const USER_RESET_PASSWORD =
  '[Manage User Access] Reset Password for User';
export const USER_RESET_PASSWORD_SUCCESS =
  '[Manage User Access] Reset Password Success';
export const USER_RESET_PASSWORD_ERROR =
  '[Manage User Access] Reset Password Error';
export const USER_RESET_PASSWORD_RESET =
  '[Manage User Access] Reset Password Reset';

export const GET_USER_TIN_LOB = '[Manage User Access] Get User TIN LOB';
export const GET_USER_TIN_LOB_SUCCESS =
  '[Manage User Access] Get User TIN LOB Success';
export const GET_USER_TIN_LOB_ERROR =
  '[Manage User Access] Get User TIN LOB Error';

export const UPDATE_USER_TIN_LOB = '[Manage User Access] Update User TIN LOB';
export const UPDATE_USER_TIN_LOB_SUCCESS =
  '[Manage User Access] Update User TIN LOB Success';
export const UPDATE_USER_TIN_LOB_ERROR =
  '[Manage User Access] Update User TIN LOB Error';

export const LOAD_USERS_FROM_DASHBOARD =
  '[Manage User Access] Load Users From Dashboard';

export const LOAD_USERS_FROM_DASHBOARD_SUCCESS =
  '[Manage User Access] Load Users From Dashboard Success';

/* wipe to initial state, useful for clearing if tab was closed and reopened */
export class Reset implements Action {
  readonly type = RESET;
}

/* DATA LOADING ACTIONS */
export class GetAllUsers implements Action {
  readonly type = GET_ALL_USERS;
  constructor(public payload: boolean = false) {}
}
export class GetAllUsersError implements Action {
  readonly type = GET_ALL_USERS_ERROR;
  constructor(public payload: ServiceError) {}
}
export class GetAllUsersSuccess implements Action {
  readonly type = GET_ALL_USERS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetPendingUsers implements Action {
  readonly type = GET_PENDING_USERS;
}
export class GetPendingUsersError implements Action {
  readonly type = GET_PENDING_USERS_ERROR;
  constructor(public payload: ServiceError) {}
}
export class GetPendingUsersSuccess implements Action {
  readonly type = GET_PENDING_USERS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetApprovedUsers implements Action {
  readonly type = GET_APPROVED_USERS;
}
export class GetApprovedUsersError implements Action {
  readonly type = GET_APPROVED_USERS_ERROR;
  constructor(public payload: ServiceError) {}
}
export class GetApprovedUsersSuccess implements Action {
  readonly type = GET_APPROVED_USERS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetUsersCached implements Action {
  readonly type = GET_USERS_CACHED;
}

export class GetUserTinEntitlements implements Action {
  readonly type = GET_USER_TIN_ENTITLEMENTS;
  constructor(public payload: boolean = false) {}
}

export class GetUserTinEntitlementsSuccess implements Action {
  readonly type = GET_USER_TIN_ENTITLEMENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetJobRoles implements Action {
  readonly type = GET_JOB_ROLES;
}

export class GetJobRolesSuccess implements Action {
  readonly type = GET_JOB_ROLES_SUCCESS;
  constructor(public payload: any) {}
}

export class GetEntitlements implements Action {
  readonly type = GET_ENTITLEMENTS;
}

export class GetEntitlementsSuccess implements Action {
  readonly type = GET_ENTITLEMENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetEligibleJobRoles implements Action {
  readonly type = GET_ELIGIBLE_JOB_ROLES;
}

export class GetEligibleJobRolesSuccess implements Action {
  readonly type = GET_ELIGIBLE_JOB_ROLES_SUCCESS;
  constructor(public payload: EligibleJobRoles) {}
}

export class GetAllTins implements Action {
  readonly type = GET_ALL_TINS;
}

export class GetAllTinsSuccess implements Action {
  readonly type = GET_ALL_TINS_SUCCESS;
  constructor(public payload: any) {}
}

/* OVERVIEW TABLE ACTIONS */
export class PageOverivewFilterGroupChange implements Action {
  readonly type = PAGE_OVERVIEW_FILTER_GROUP_CHANGE;
  constructor(public payload: FILTER_GROUP) {}
}

export class PageOverviewFilterTextChange implements Action {
  readonly type = PAGE_OVERVIEW_FILTER_TEXT_CHANGE;
  constructor(public payload: string) {}
}

export class SelectUserToEdit implements Action {
  readonly type = SELECT_USER_TO_EDIT;
  constructor(public payload: User) {}
}

export class UnSelectUserToEdit implements Action {
  readonly type = UNSELECT_USER_TO_EDIT;
  constructor(public payload: User) {}
}

export class SelectAllUsersToEdit implements Action {
  readonly type = SELECT_ALL_USERS_TO_EDIT;
}

export class SetSelectedUsers implements Action {
  readonly type = SET_SELECTED_USERS;
  constructor(public payload: EditedUser[]) {}
}

export class SelectUserToPrintEmail implements Action {
  readonly type = SELECT_USER_TO_PRINT_EMAIL;
  constructor(public payload: EditedUser) {}
}

export class UnSelectUserToPrintEmail implements Action {
  readonly type = UNSELECT_USER_TO_PRINT_EMAIL;
  constructor(public payload: EditedUser) {}
}

export class SelectAllUsersToPrintEmail implements Action {
  readonly type = SELECT_ALL_USERS_TO_PRINT_EMAIL;
  constructor(public payload: boolean) {}
}

export class ViewAccessForUser implements Action {
  readonly type = VIEW_ACCESS_FOR_USER;
  constructor(public payload: User) {}
}

export class ViewAccessForUserSuccess implements Action {
  readonly type = VIEW_ACCESS_FOR_USER_SUCCESS;
  constructor(public payload: User) {}
}

export class ViewAccessForUserError implements Action {
  readonly type = VIEW_ACCESS_FOR_USER_ERROR;
}

export class ViewAccessForUserReset implements Action {
  readonly type = VIEW_ACCESS_FOR_USER_RESET;
}

export class UnSelectAllUsersToEdit implements Action {
  readonly type = UNSELECT_ALL_USERS_TO_EDIT;
}

/* ACCESS FLOW ACTIONS */
export class CancelEditUserFlow implements Action {
  readonly type = CANCEL_EDIT_USER_FLOW;
}

export class AddNewUsers implements Action {
  readonly type = ADD_NEW_USERS;
}

export class SelectAndEditUser implements Action {
  readonly type = SELECT_AND_EDIT_USER;
  constructor(public payload: User) {}
}

export class ViewAndEditUsers implements Action {
  readonly type = VIEW_AND_EDIT_USERS;
}

export class AddUsersAndStartAssignment implements Action {
  readonly type = ADD_USERS_AND_START_ASSIGNMENT;
  constructor(public payload: EditedUser[]) {}
}

export class SetAssignmentMethodAndAssign implements Action {
  readonly type = SET_ASSIGNMENT_METHOD_AND_ASSIGN;
  constructor(public payload: string) {}
}

/* EDITING ACTIONS */

export class ScaffoldSelectedUsers implements Action {
  readonly type = SCAFFOLD_SELECTED_USERS;
  constructor(public payload: EditedUser[]) {}
}

export class TriggerUserScaffolding implements Action {
  readonly type = TRIGGER_USER_SCAFFOLDING;
}

export class ApplyEntitlementsByJobRole implements Action {
  readonly type = APPLY_ENTITLEMENTS_BY_JOB_ROLE;
  constructor(
    public payload: {
      tin: TinAccess;
      user: EditedUser;
    },
  ) {}
}
export class RevertEntitlementsToExisting implements Action {
  readonly type = REVERT_ENTITLEMENTS_TO_EXISTING;
  constructor(
    public payload: {
      tin: TinAccess;
      user: EditedUser;
    },
  ) {}
}

export class UpdateEditedUserIndividual implements Action {
  readonly type = UPDATE_EDITED_USER_INDIVIDUAL;
  constructor(
    public payload: {
      entitlements: EntitlementRole[];
      tin: TinAccess;
      user: EditedUser;
    },
  ) {}
}

export class UpdateEditedUsersBulkEntitlements implements Action {
  readonly type = UPDATE_EDITED_USERS_BULK_ENTITLEMENTS;
  constructor(public payload: EntitlementRole[]) {}
}

export class UpdateEditedUsersBulkTins implements Action {
  readonly type = UPDATE_EDITED_USERS_BULK_TINS;
  constructor(public payload: TinLob[]) {}
}

export class BulkEditApplyChanges implements Action {
  readonly type = BULK_EDIT_APPLY_CHANGES;
}

export class UpdateEditedUsersBulkAndContinue implements Action {
  readonly type = UPDATE_EDITED_USERS_BULK_AND_CONTINUE;
  constructor(public payload: EditedUser[]) {}
}

export class ShowEditErrors implements Action {
  readonly type = SHOW_EDIT_ERRORS;
  constructor(
    public payload: {
      error: ServiceError;
      overTinLimit: [
        {
          userId: string;
        },
      ];
      overDelegateLimit: [
        {
          userId: string;
          tin: string;
          tinName: string;
        },
      ];
      lastAMForTin: [
        {
          userId: string;
          tin: string;
          tinName: string;
        },
      ];
    },
  ) {}
}

export class ProceedWithEditErrors implements Action {
  readonly type = PROCEED_WITH_EDIT_ERRORS;
}

export class BackToAssignAccess implements Action {
  readonly type = BACK_TO_ASSIGN_ACCESS;
}

export class UsersSubmit implements Action {
  readonly type = USERS_SUBMIT;
}

export class AssignUsersSubmit implements Action {
  readonly type = ASSIGN_USERS_SUBMIT;
  constructor(public payload: EditedUser[]) {}
}

export class AssignUsersSuccess implements Action {
  readonly type = ASSIGN_USERS_SUCCESS;
  constructor(public payload: any) {}
}

export class AssignUsersError implements Action {
  readonly type = ASSIGN_USERS_ERROR;
  constructor(public payload: ServiceError) {}
}

export class AddUsersSubmit implements Action {
  readonly type = ADD_USERS_SUBMIT;
  constructor(public payload: EditedUser[]) {}
}

export class AddUsersSuccess implements Action {
  readonly type = ADD_USERS_SUCCESS;
  constructor(public payload: any[]) {}
}

export class AddUsersSuccessMerge implements Action {
  readonly type = ADD_USERS_SUCCESS_MERGE;
  constructor(public payload: any[]) {}
}

export class AddUsersNoLobError implements Action {
  readonly type = ADD_USERS_NO_LOB_ERROR;
}

export class AddUsersError implements Action {
  readonly type = ADD_USERS_ERROR;
  constructor(public payload: ServiceError) {}
}

export class UserRemoveAccess implements Action {
  readonly type = USER_REMOVE_ACCESS;
  constructor(
    public payload: {
      userId: string;
      tins: TinLob[];
    },
  ) {}
}

export class UserRemoveAccessSuccess implements Action {
  readonly type = USER_REMOVE_ACCESS_SUCCESS;
  constructor(public payload: any) {}
}

export class UserRemoveAccessError implements Action {
  readonly type = USER_REMOVE_ACCESS_ERROR;
  constructor(public payload: ServiceError) {}
}

export class UserRemoveAccessReset implements Action {
  readonly type = USER_REMOVE_ACCESS_RESET;
}

export class GetUserTinLOB implements Action {
  readonly type = GET_USER_TIN_LOB;
  constructor(public userId: string) {}
}
export class GetUserTinLOBSuccess implements Action {
  readonly type = GET_USER_TIN_LOB_SUCCESS;
  constructor(public userTins: UserTinLob[]) {}
}

export class GetUserTinLOBError implements Action {
  readonly type = GET_USER_TIN_LOB_ERROR;
  constructor(public error: ServiceError) {}
}
export class UpdateUserTinLOB implements Action {
  readonly type = UPDATE_USER_TIN_LOB;
  constructor(public payload: { userId: string; lobPref: string }) {}
}
export class UpdateUserTinLOBSuccess implements Action {
  readonly type = UPDATE_USER_TIN_LOB_SUCCESS;
  constructor(public payload: { userId: string; lobPref: string }) {}
}
export class UpdateUserTinLOBError implements Action {
  readonly type = UPDATE_USER_TIN_LOB_ERROR;
  constructor(public error: ServiceError) {}
}

export class UserResetPassword implements Action {
  readonly type = USER_RESET_PASSWORD;
  constructor(public payload: string) {}
}

export class UserResetPasswordSuccess implements Action {
  readonly type = USER_RESET_PASSWORD_SUCCESS;
  constructor(
    public payload: {
      userId: string;
      temporaryPassword: string;
    },
  ) {}
}

export class UserResetPasswordError implements Action {
  readonly type = USER_RESET_PASSWORD_ERROR;
  constructor(public payload: ServiceError) {}
}

export class UserResetPasswordReset implements Action {
  readonly type = USER_RESET_PASSWORD_RESET;
}

export class LoadUsersFromDashboard implements Action {
  readonly type = LOAD_USERS_FROM_DASHBOARD;
  constructor(public payload: string[]) {}
}

export class LoadUsersFromDashboardSuccess implements Action {
  readonly type = LOAD_USERS_FROM_DASHBOARD_SUCCESS;
  constructor(
    public payload: {
      users: User[];
      userIds: string[];
      selectedUsers: EditedUser[];
    },
  ) {}
}

export type ManageUserAccessAction =
  | Reset
  | GetAllUsers
  | GetAllUsersError
  | GetAllUsersSuccess
  | GetPendingUsers
  | GetPendingUsersSuccess
  | GetPendingUsersError
  | GetApprovedUsers
  | GetApprovedUsersSuccess
  | GetApprovedUsersError
  | GetUsersCached
  | GetUserTinEntitlements
  | GetUserTinEntitlementsSuccess
  | GetJobRoles
  | GetJobRolesSuccess
  | GetEntitlements
  | GetEntitlementsSuccess
  | GetEligibleJobRoles
  | GetEligibleJobRolesSuccess
  | GetAllTins
  | GetAllTinsSuccess
  | ViewAccessForUser
  | ViewAccessForUserSuccess
  | ViewAccessForUserError
  | ViewAccessForUserReset
  | PageOverivewFilterGroupChange
  | PageOverviewFilterTextChange
  | CancelEditUserFlow
  | SelectAndEditUser
  | ViewAndEditUsers
  | AddNewUsers
  | AddUsersAndStartAssignment
  | SetAssignmentMethodAndAssign
  | SelectUserToEdit
  | UnSelectUserToEdit
  | SelectAllUsersToEdit
  | SelectAllUsersToPrintEmail
  | SelectUserToPrintEmail
  | SetSelectedUsers
  | UnSelectUserToPrintEmail
  | UnSelectAllUsersToEdit
  | ScaffoldSelectedUsers
  | UpdateEditedUserIndividual
  | UpdateEditedUsersBulkEntitlements
  | UpdateEditedUsersBulkTins
  | ShowEditErrors
  | ProceedWithEditErrors
  | BulkEditApplyChanges
  | UpdateEditedUsersBulkAndContinue
  | BackToAssignAccess
  | UsersSubmit
  | AddUsersSubmit
  | AddUsersSuccess
  | AddUsersSuccessMerge
  | AddUsersError
  | AddUsersNoLobError
  | AssignUsersSubmit
  | AssignUsersSuccess
  | AssignUsersError
  | UserRemoveAccess
  | UserRemoveAccessSuccess
  | UserRemoveAccessError
  | UserRemoveAccessReset
  | GetUserTinLOB
  | GetUserTinLOBSuccess
  | GetUserTinLOBError
  | UpdateUserTinLOB
  | UpdateUserTinLOBSuccess
  | UpdateUserTinLOBError
  | UserResetPassword
  | UserResetPasswordSuccess
  | UserResetPasswordError
  | UserResetPasswordReset
  | LoadUsersFromDashboard
  | LoadUsersFromDashboardSuccess;
